import {Component, inject, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import { Store } from "@ngrx/store";
import {take} from "rxjs/operators";
import { RestUrlsConfig, GenericConfig } from '@signature-it/ngx-generic/config';
import {RouteService} from '@signature-it/ngx-generic/services';
import * as EntityActions from '@signature-it/ngx-entity/store/actions';
import {SolrService, SharedDataService, GroupApiService} from '@signature-it/ngx-catalogue/services';
import {SolrDocsDTO, ProductSolrDTO, Group, CampaignDTO, CatalogueBlockDTO} from '@signature-it/ngx-catalogue/models';
import { CatalogueActions } from '@signature-it/ngx-catalogue/store/actions';
import {ProductCardComponent} from './product-card/product-card.component';
import {FamilyCardComponent} from './family-card/family-card.component';

declare let _: any;

@Component({
    selector: 'products-cards',
    templateUrl: './products-cards.component.html',
    styleUrls: ['./products-cards.component.scss'],
    standalone: false
})
export class ProductsCardsComponent implements OnChanges, OnInit {
    isBottomPagination: boolean = false;

    topPaginationContext = { isBottom: false };
    bottomPaginationContext = { isBottom: true };
    @Input() items: Array<SolrDocsDTO>;
    @Input() totalItems:any;
    @Input() page:any;
    _itemsPerPage: number ;
    @Input() set itemsPerPage(value){
        this._itemsPerPage = Number(value);
    }
    @Input() showSortOptions = false;
    @Input() group: Group;

    @ViewChild('productCard') protected productCard: ProductCardComponent;
    @ViewChild('familyCard') protected familyCard: FamilyCardComponent;

    public loading:boolean = true;
    public quantity:any = {};
    public urlDetails:any = {
        groupId: "",
        leaf: ""
    };
    displayItemsMode: string = GenericConfig.displayItemsMode || 'grid';
    doNotRedirectSingleProduct:boolean = GenericConfig.doNotRedirectSingleProduct;
    productItemsInRowOnGridMode = GenericConfig.productItemsInRowOnGridMode || { xs: 1, sm: 1, md: 2, lg: 3, xl: 4, xxl: 5 };
    itemPerPageSelect:Array<number> = GenericConfig.item_per_page;
    hideResultsPerPageSelect: boolean = GenericConfig.hideResultsPerPageSelect || false;
    noResultsCms = 'ngx-no-result-found-cms';
    inventoryCheck = GenericConfig.inventoryCheck;
    routeService: RouteService;
    groupSvc: GroupApiService;
    campaignsData:  Array<CatalogueBlockDTO>;
    blocks: Array<CatalogueBlockDTO>;

    constructor(protected router: Router,
                protected solrService: SolrService,
                public sharedSvc: SharedDataService,
                public restUrlsConfig: RestUrlsConfig,
                public route: ActivatedRoute,
                protected store$: Store<any> ) {
        this.routeService = inject(RouteService);
        this.groupSvc = inject(GroupApiService);
    }

    ngOnInit() {
        // get previews for ProductCardComponent using.
        this.store$.dispatch(EntityActions.getPreviews());
        if(GenericConfig.catalogueBlocks && this.group && this.group.id ) {
            this.groupSvc.getCatalogueBlocks(this.group.id).subscribe((blocks : any )=>{
                this.blocks = blocks;
            });
        }
        this._itemsPerPage = this._itemsPerPage || GenericConfig.item_per_page[0];
        this.routeService.data$.pipe(take(1)).subscribe(data => {
            if (data && data.camaignData) {
                this.campaignsData = []
                const self = this;
                data.camaignData.forEach(item => {
                    self.campaignsData.push(new CatalogueBlockDTO(item))
                });
            }
        })
    }

    loadPage(event) {
        if(!isNaN(event)) {
            this.router.navigate([], {queryParams: { page: event }, queryParamsHandling: "merge"});
            window.scrollTo(0,0);
        }
    }

    loadItemPerPage(num) {
        this.router.navigate([], {queryParams: {itemsPerPage: num }, queryParamsHandling: "merge"});
    }

    getProductsIDs(productsDocs: SolrDocsDTO) {
        let pIds = _.map(productsDocs, (doc) => {
            return doc.products[0].product_id_i;
        });
        return pIds;
    }

    getProductsCodes(productsDocs: SolrDocsDTO) {
        let pCodes = _.map(productsDocs, (doc) => {
            return doc.products[0].product_code_s;
        });
        return pCodes;
    }

    ngOnChanges(changes: SimpleChanges): void {
        this._itemsPerPage = this._itemsPerPage || GenericConfig.item_per_page[0];
        if(changes['items'] && this.items) {
            let productsDocs = _.filter(this.items, {'isFamily': false, 'isBucket': false});
            if(!GenericConfig.unCommerceApp && productsDocs.length) {
                this._getProductsPriceAction(this.getProductsIDs(productsDocs));
                if(this.inventoryCheck) {
                    this._getProductsStockAction(this.getProductsCodes(productsDocs));
                }
            }
            this.loading = false;
        }
        if(changes['items'] && this.items && !this.doNotRedirectSingleProduct && this.items.length == 1 && this.page == 1) {
            if(this.items[0].isFamily) {
                this.goToFamily(this.items[0].products[0]);
            } else {
                this.goToProduct(this.items[0].products[0]);
            }
        }
    }

    goToFamily(family: ProductSolrDTO) {
        let params = this.router.parseUrl(this.router.url).queryParams;
        delete params.page;
        delete params.itemsPerPage;
        this.router.navigate([this.group.catalogueUrl, family.group_id_i, family.group_slug_s, family.FamilyNameSlug_s], {queryParams: params});
    }


    goToProduct(product: ProductSolrDTO) {
        if (product.productUrl) {
            this.router.navigate([product.productUrl]);
        } else {
            this.router.navigate(['/product-page', product.product_id_i]);
        }
    }
    changeItemsDisplay(modeClass){
        this.displayItemsMode =  modeClass;
    }

    /** Actions */

    protected _getProductsPriceAction(pIds: Array<number>) {
        const action = CatalogueActions.getProductPrice(pIds);
        this.store$.dispatch(action);
    }

    protected _getProductsStockAction(pCodes: Array<any>) {
        const action = CatalogueActions.getProductsStock(pCodes);
        this.store$.dispatch(action);
    }
}
